import { Record, Iterable, fromJS } from 'immutable';
import TwoFactorAuthConfig from './TwoFactorAuthConfig';
import GoogleAuthQRCode from './GoogleAuthQRCode';
const TwoFactorAuthConfigureResponse = Record({
  config: null,
  qrInfo: null
});
function fromJSReviver(key, value) {
  const isIndexed = Iterable.isIndexed(value);
  if (key === 'config') {
    return new TwoFactorAuthConfig(value);
  } else if (key === 'qrInfo') {
    return new GoogleAuthQRCode(value);
  }
  return isIndexed ? value.toList() : value.toMap();
}
export function fromJSON(obj) {
  return new TwoFactorAuthConfigureResponse(fromJS(obj, fromJSReviver));
}
export default TwoFactorAuthConfigureResponse;